import React from 'react';
import { Alert, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function ChannelFootageNotice({ channel, kind, folder }) {
  if (!channel?.id) return null;
  const selectedFolder = folder === undefined ? channel.footageFolder : folder;
  return (
    <Alert severity={selectedFolder ? 'info' : 'error'} sx={{ my: 2 }}
      action={
        <Button color="inherit" size="small" component={RouterLink}
          to={`/channels/${kind}?channelId=${encodeURIComponent(channel.id)}`}>
          Configure channel
        </Button>
      }>
      {selectedFolder
        ? `Channel footage: ${selectedFolder.name}`
        : `Configure a footage folder for "${channel.name}" before creating or rendering a video.`}
    </Alert>
  );
}
